import type { Project, RunningTimer, TimeEntry, WorkspaceState } from './types';

export class ApiError extends Error {
  constructor(message: string, public status: number) { super(message); }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    ...init,
    headers: { 'Content-Type': 'application/json', ...init?.headers },
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({ error: response.statusText })) as { error?: string };
    throw new ApiError(body.error ?? 'Request failed', response.status);
  }
  return response.json() as Promise<T>;
}

export const loadWorkspace = () => request<WorkspaceState>('/api/state');
export const createRemoteProject = (project: Project) => request<Project>('/api/projects', { method: 'POST', body: JSON.stringify(project) });
export const createRemoteEntry = (entry: TimeEntry) => request<TimeEntry>('/api/entries', { method: 'POST', body: JSON.stringify(entry) });
export const startRemoteTimer = (timer: RunningTimer) => request<RunningTimer>('/api/timer', { method: 'POST', body: JSON.stringify({ action: 'start', ...timer }) });
export const stopRemoteTimer = (timerId: string, endedAt: string) => request<TimeEntry>('/api/timer', { method: 'POST', body: JSON.stringify({ action: 'stop', timerId, endedAt }) });
